import { Routes } from '@angular/router';
import { authGuard } from '@auth/guards/auth.guard';
import { publicGuard } from '@auth/guards/public.guard';
import { roleGuard } from '@auth/guards/role.guard';
import { defaultRouteRedirect } from '@auth/guards/default-route.redirect';
import { ADMIN_ROLES } from '@auth/helpers/user-roles';

export const routes: Routes = [
  {
    path:'auth',
    title:'auth',
    canActivate: [publicGuard],
    loadComponent: () => import('./auth/auth-layout/auth-layout.component'),
    children: [
      {
        path:'login',
        title:'Login',
        loadComponent: () => import('./auth/pages/login-page/login-page.component')
      },
      {
        path:'recover',
        title:'Recover',
        loadComponent: () => import('./auth/pages/recover-page/recover-page.component')
      },
      {
        path:'challenge',
        title:'Verificar código',
        loadComponent: () => import('./auth/pages/challenge-page/challenge-page.component')
      },
      {
        path:'change-password',
        title:'Cambiar contraseña',
        loadComponent: () => import('./auth/pages/change-password-page/change-password-page.component')
      },
      {
        path:'register',
        title:'Register',
        loadComponent: () => import('./auth/pages/register-page/register-page.component')
      }
    ]
  },
  {
    // menu-layout pone <nsc-nav-main> UNA sola vez y por encima del
    // <router-outlet>: así la barra superior no se destruye/recrea al
    // navegar entre el árbol de menús (menu/:menuId) y las páginas de
    // "Listados" (listados/xxx), que hasta ahora eran ramas de rutas
    // completamente separadas sin ningún ancestro común.
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./menu/menu-layout/menu-layout.component'),
    children: [
      {
        path:'menu/:menuId',
        title: 'Menú',
        loadComponent: () => import('./menu/pages/menu-page/menu-page.component')
      },
      { path: 'menu', redirectTo: 'menu/0', pathMatch: 'full' },
      {
        path: 'listados',
        title:"Listado de vacaciones",
        children: [
          {
            path: 'listholidays',
            loadComponent: () => import('./listados/pages/holiday-page/holiday-page.component').then(m => m.HolidayPageComponent),
          },
        ],
      },
      {
        path: 'solicitudes',
        children: [
          {
            path: 'requestholidays',
            title: "Solicitud de vacaciones",
            loadComponent: () => import('./tools/pages/holidays-page/holidays-page.component'),
          },
        ],
      },         
    ],
  },
  {
    path:'users',
    canActivate: [authGuard],
    loadComponent: () => import('./users/users-layout/users-layout.component'),
    children: [
      {
        path:'month-report',
        title: 'Informe Mensual',
        loadComponent: () => import('./users/pages/users-month-report-page/users-month-report-page.component')
      },
      {
        path:'daysoff',
        loadComponent: () => import('./users/pages/users-days-off-page/users-days-off-page.component')
      },
      {
        path:'profile/:userId',
        loadComponent: () => import('./users/pages/user-profile-page/user-profile-page.component')
      },
      {
        path: '**', redirectTo: 'month-report', pathMatch: 'full'
      },
    ]
  },
  {
    path:'tools',
    canActivate: [authGuard, roleGuard(...ADMIN_ROLES)],
    loadComponent: () => import('./tools/tools-layout/tools-layout.component'),
    children: [
      {
        path:'daysoff-allocator',
        loadComponent: () => import('./tools/pages/days-off-allocator-page/days-off-allocator-page.component')
      },
      {
        path: 'test',
        loadComponent: () => import('./tools/components/table-test01/table-test01.component').then(m => m.TableTest01Component),
      },
      {path: '**', redirectTo: 'daysoff-allocator', pathMatch: 'full'},
    ]
  },
  {
    path:'fichaje',
    canActivate: [authGuard],
    loadComponent: () => import('./fichaje/fichaje-layout/fichaje-layout.component'),
    children: [
      {
        path: ':inputStringDayISO',
        loadComponent: () => import('./fichaje/pages/web-fichaje-page/web-fichaje-page.component'),
      },
      {
        path: '',
        redirectTo: 'any', // genera /fichaje/any
        pathMatch: 'full'
      },
    ]
  },



  // Rutas desconocidas (y '/'): login sin sesión; con sesión, /menu o /fichaje según rol.
  {path: '**', redirectTo: defaultRouteRedirect},
];

